import { Pipe, PipeTransform, Type } from '@angular/core';

import { DynamicIdtComponentService } from 'shared/dynamic/dynamic-idt-component.service';
import { IdtComponent } from 'shared/models/idt-components/idt-component.models';


@Pipe({ name: 'dynamicIdtComponentResolution' })
export class DynamicIdtComponentResolutionPipe implements PipeTransform {

  constructor(private readonly dynamicIdtComponentService: DynamicIdtComponentService) {}

  public transform(component: IdtComponent, type: string): Type<any> {
    return this.dynamicIdtComponentService.componentByDefinition(
      component.definitionId,
      type
    );
  }

}
